import(/* webpackMode: "eager" */ "/app/app/[locale]/map/page.tsx");
